import React from 'react';
import Abook from './index';
import ErrorBoundary from '../../../components/ErrorBoundary';

const AbookNotifications = React.lazy(() => import('./AbookNotifications'));
const HelpButton = React.lazy(() => import('../../../components/HelpButton'));
const AbookNotificationsPage = (props) => (
  <Abook scrolling>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <>
          <div className="text-right">
            <HelpButton fileName="notifications-abook" />
          </div>
          <AbookNotifications {...props} />
        </>
      </React.Suspense>
    </ErrorBoundary>
  </Abook>
);

export default AbookNotificationsPage;
